interface EgoLinkProps {
  id?: number | string | null;
  label: string;
  kind: EgoLinkKind;
  url?: string | null;
}

export type EgoLinkKind = "person" | "lead";
export type CrmFinalEmissionKind = "opportunity" | "lead_realestate" | "lead" | (string & {});

export interface CrmFinalTarget {
  id: number | string | null;
  label: string;
  url: string | null;
}

const EGO_BASE_URL = "https://admin.egorealestate.com/egocore";
const EGO_INTERNET_LEADS_URL = `${EGO_BASE_URL}/internetleads`;

function cleanEgoId(id?: number | string | null): string | null {
  const value = String(id ?? "").trim();
  if (!value) return null;
  const normalized = value.toLowerCase();
  if (normalized === "null" || normalized === "undefined") return null;
  return value;
}

export function buildEgoUrl(
  kind: EgoLinkKind,
  id?: number | string | null,
): string | null {
  const stableId = cleanEgoId(id);
  if (stableId) return `${EGO_BASE_URL}/${kind}/${encodeURIComponent(stableId)}`;
  return null;
}

export function crmFinalLabel(kind?: string | null, compact = false): string {
  if (kind === "opportunity") return compact ? "Opportunity" : "Opportunity eGO";
  if (kind === "lead_realestate") return compact ? "Lead imóvel" : "Lead RealEstate eGO";
  if (kind === "lead") return compact ? "Lead" : "Lead eGO";
  return compact ? "CRM" : "CRM final eGO";
}

export function getCrmFinalTarget(
  kind?: string | null,
  opportunityId?: number | string | null,
  leadId?: number | string | null,
  opportunityUrl?: string | null,
  leadUrl?: string | null,
): CrmFinalTarget {
  if (kind === "lead" || kind === "lead_realestate") {
    const validatedLeadUrl = leadUrl === EGO_INTERNET_LEADS_URL ? leadUrl : null;
    return {
      id: null,
      label: crmFinalLabel(kind, true),
      url: validatedLeadUrl || EGO_INTERNET_LEADS_URL,
    };
  }
  const id = kind === "opportunity" ? opportunityId ?? null : leadId ?? null;
  return {
    id,
    label: crmFinalLabel(kind, true),
    url: opportunityUrl || buildEgoUrl("lead", id),
  };
}

export function EgoLink({ id, label, kind, url }: EgoLinkProps) {
  const stableId = cleanEgoId(id);
  const safeHref = url || buildEgoUrl(kind, stableId);
  if (!safeHref) return <span class="inspector-muted">—</span>;
  const text = stableId ? `${label} ${stableId}` : label;
  return (
    <a class="inline-link" href={safeHref} target="_blank" rel="noopener">
      {text}
    </a>
  );
}
